
  import { defineComponent } from 'vue';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import PageTitle from '@/common/components/redesigned/PageTitle.vue';
  import Constants from '@/common/constants';
  import { MIME_TYPES } from '@/common/constants/mimeTypes';
  import security from '@/common/mixins/security';
  import { TFileType } from '@/common/types/file';

  import ImportModal from '@/components/modals/ImportModal.vue';
  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import Api from '../api/index';

  const PERMISSIONS = {
    view: Constants.Permissions.AnalyticsImportView,
  };

  type TImportConfig = {
    title: string;
    fileType: TFileType;
    apiRoute: string;
    addFormData?: Record<string, string | number>;
  };

  export default defineComponent({
    name: 'SwaggerUpload',
    components: { ImportModal, ModalComponent, ButtonComponent, PageTitle },
    mixins: [security],
    data(): {
      route: string;
      importInProgress: boolean;
      importModal: boolean;
      importConfig: TImportConfig[];
      configItem: TImportConfig | null;
    } {
      return {
        route: 'SwaggerUpload',
        importInProgress: false,
        importModal: false,

        configItem: null,
        importConfig: [
          {
            title: 'Дефицит бюджета',
            fileType: 'xml',
            apiRoute: '/keyindicators/budgetdeficitfile',
          },
          {
            title: 'Капитализация рынка акций',
            fileType: 'xlsx',
            apiRoute: '/keyindicators/stockmarketcapitalizationfile',
          },
          {
            title: 'Доходность государственных облигаций и Доходность гос. ценных бумаг',
            fileType: 'xlsx',
            apiRoute: '/keyindicators/governmentbondyieldsfile',
          },
          {
            title: 'Рост ВВП в сравнении с другими странами (%, г/г)',
            fileType: 'xml',
            apiRoute: '/foreigntradeturnoverworld/gdpvaluesfile',
          },
          // TODO: сделать расширение с добавлением параметров в body через модалку
          // {
          //   title: 'Топ 5 отраслей импорта',
          //   fileType: 'xlsx',
          //   apiRoute: '/foreigntradeturnoverworld/importindustriesfile',
          //   addFormData: {
          //     countryId: '',
          //   },
          // },
          // {
          //   title: 'Топ 5 отраслей экспорта',
          //   fileType: 'xlsx',
          //   apiRoute: '/foreigntradeturnoverworld/exportindustriesfile',
          //   addFormData: {
          //     countryId: '',
          //   },
          // },
          // {
          //   title: 'График Топ 5 стран экспорта',
          //   fileType: 'xlsx',
          //   apiRoute: '/foreigntradeturnoverworld/exportcountriesfile',
          //   addFormData: {
          //     countryId: '',
          //   },
          // },
          // {
          //   title: 'Топ 5 стран импорта',
          //   fileType: 'xlsx',
          //   apiRoute: '/foreigntradeturnoverworld/importcountriesfile',
          //   addFormData: {
          //     countryId: '',
          //   },
          // },
        ],
      };
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view);
    },
    computed: {
      getMimeType() {
        if (!this.configItem?.fileType) return undefined;
        return MIME_TYPES[this.configItem.fileType];
      },
    },
    methods: {
      importExcel(configItem: TImportConfig) {
        this.configItem = configItem;
        this.importModal = true;
      },
      doImport(file: File) {
        this.closeModal();
        this.importInProgress = true;
        Api.downloadFile(this.route, file, { customRoute: this.configItem?.apiRoute })
          .then(() => {
            Constants.alert.fire('Импорт', 'Импорт успешно выполнен.', 'success');
          })
          .catch((error) => {
            Constants.alert.fire(
              'Импорт',
              error?.response?.data ? error?.response?.data : 'Ошибка при импорте данных.',
              'error',
            );
          })
          .finally(() => {
            this.importInProgress = false;
            this.configItem = null;
          });
      },
      closeModal() {
        this.importModal = false;
      },
    },
  });
